import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { InferenceRun } from '../models/truth-management.model';

@Injectable({
  providedIn: 'root'
})
export class InferenceRunService {
  private inferenceRunsSubject: BehaviorSubject<InferenceRun[]>;
  public inferenceRuns$: Observable<InferenceRun[]>;

  constructor() {
    // Initialize with empty array - no localStorage persistence
    this.inferenceRunsSubject = new BehaviorSubject<InferenceRun[]>([]);
    this.inferenceRuns$ = this.inferenceRunsSubject.asObservable();
  }

  getAllRuns(): InferenceRun[] {
    return this.inferenceRunsSubject.value;
  }

  getRunById(id: number): InferenceRun | undefined {
    return this.inferenceRunsSubject.value.find(run => run.id === id);
  }

  addRun(run: InferenceRun): void {
    const currentRuns = this.inferenceRunsSubject.value;
    const updatedRuns = [run, ...currentRuns];
    this.inferenceRunsSubject.next(updatedRuns);
    // Data kept in-memory only - no localStorage persistence
  }

  updateRunProgress(id: number, progress: number, status: 'Pending' | 'Running' | 'Completed' | 'Failed'): void {
    const currentRuns = this.inferenceRunsSubject.value;
    const updatedRuns = currentRuns.map(run => 
      run.id === id ? { ...run, progress, status } : run
    );
    this.inferenceRunsSubject.next(updatedRuns);
    // Data kept in-memory only - no localStorage persistence
  }

  deleteRun(id: number): void {
    const currentRuns = this.inferenceRunsSubject.value;
    const updatedRuns = currentRuns.filter(run => run.id !== id);
    this.inferenceRunsSubject.next(updatedRuns);
    // Data kept in-memory only - no localStorage persistence
  }

  getNextId(): number {
    const currentRuns = this.inferenceRunsSubject.value;
    if (currentRuns.length === 0) return 1;
    return Math.max(...currentRuns.map(run => run.id)) + 1;
  }
}
